import AlertBox from "@/app/[locale]/auth/login/components/UI/AlertBox";

type Props = {
  isRegistration: boolean;
  currentTpaProvider?: string | null;
};

export default function TpaMessage({
  isRegistration,
  currentTpaProvider,
}: Props) {
  const message = isRegistration
    ? `You've successfully signed into ${currentTpaProvider}! We just need a little more information before you start learning with edX`
    : `You have successfully signed into ${currentTpaProvider}, but your ${currentTpaProvider} account does not have a linked edX account. To link your accounts, sign in now using your edx password.`;

  return (
    currentTpaProvider && (
      <AlertBox
        message={message}
        type="message"
        hasIcon={false}
        title={isRegistration ? "Almost Done!" : ""}
      />
    )
  );
}
